import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { isVideoFile } from './useCardVideoUpload';

const frameSx = {
  position: 'relative' as const,
  bgcolor: '#111',
  height: 160,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

interface VideoZoneFailedViewProps {
  index: number;
  message: string;
  onVideoFile: (file: File) => void;
  onOpenLibrary: () => void;
}

/** Failed-processing state: drop another file to replace it, or pick one from the library. */
export default function VideoZoneFailedView({
  index,
  message,
  onVideoFile,
  onOpenLibrary,
}: VideoZoneFailedViewProps) {
  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={`Slide ${index + 1} video failed — drop another file to replace it`}
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && isVideoFile(file)) onVideoFile(file);
      }}
      sx={{ ...frameSx, flexDirection: 'column', gap: 0.5, px: 2, cursor: 'pointer' }}
    >
      <Typography variant="caption" sx={{ color: '#fff', textAlign: 'center' }}>
        {message}
      </Typography>
      <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', textAlign: 'center' }}>
        Drop another file, or use one from the library
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={(event) => {
          event.stopPropagation();
          onOpenLibrary();
        }}
        sx={{ mt: 0.5, color: '#fff', borderColor: 'rgba(255,255,255,0.6)' }}
      >
        Choose from library
      </Button>
    </Box>
  );
}
